import React, { useRef } from "react";
import NavTabs from "~components/NavTabs";

import "./style.scss";
import FunnelClientSearch from "./FunnelClientSearch";

const FunnelTabs = ({ tabs, hideSearch }) => {
  return (
    <>
      <NavTabs navs={tabs} white />

      {!hideSearch && <FunnelClientSearch />}
    </>
  );
};

export default FunnelTabs;
